import React from 'react';
import { Play } from 'lucide-react';

export default function BrandLogo({ compact = false, tiny = false, muted = false, iconOnly = false, className = '' }) {
  const iconSize = tiny ? 12 : compact ? 14 : 16;
  const badgeSize = tiny ? '24px' : compact ? '30px' : '34px';

  return (
    <div 
      className={`brand-logo-container ${className}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', userSelect: 'none' }}
    >
      <div
        style={{
          width: badgeSize,
          height: badgeSize,
          borderRadius: '9px',
          background: muted
            ? 'rgba(255, 255, 255, 0.1)'
            : 'linear-gradient(135deg, #00c9ff 0%, #0078ff 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ffffff',
          boxShadow: muted ? 'none' : '0 4px 14px rgba(0, 201, 255, 0.4)',
          flexShrink: 0
        }}
      >
        {Play ? <Play size={iconSize} fill="currentColor" style={{ marginLeft: 2 }} /> : <span>▶</span>}
      </div>

      {!iconOnly && (
        <span
          style={{
            fontFamily: "'Space Grotesk', 'Manrope', sans-serif",
            fontWeight: 800,
            fontSize: tiny ? '0.8rem' : compact ? '0.92rem' : '1.05rem',
            letterSpacing: '0.6px',
            color: muted ? '#94a3b8' : '#00d2ff',
            background: muted ? 'none' : 'linear-gradient(135deg, #00d2ff 0%, #3b82f6 100%)',
            WebkitBackgroundClip: muted ? 'unset' : 'text',
            WebkitTextFillColor: muted ? 'inherit' : 'transparent',
            whiteSpace: 'nowrap'
          }}
        >
          WEB IPTV PLAYER
        </span>
      )}
    </div>
  );
}
